import { WarningIcon } from '../icons/Warning'
import { InfoIcon } from '../icons/Info'
import styles from './MessageBox.module.css'

interface MessageBox {
  type: 'info' | 'warning' | 'error' | 'noIcon',
  withTitle: boolean,
  title?: string,
  message?: string,
}

function MessageBox ({ type, withTitle, title, message }: MessageBox) {
  let cssClass = ''
  let messageIcon
  switch (type) {
    case 'warning':
      cssClass = 'warning'
      // messageIcon = <WarningIcon color='#E84C05' className={styles.errorIcon} />
      break
    case 'error':
      cssClass = 'error'
      messageIcon = <WarningIcon color='#E3000B' className={styles.errorIcon} />
      break
    case 'noIcon':
      cssClass = 'info'
      messageIcon = ''
      break
    default:
      cssClass = 'info'
      messageIcon = <InfoIcon color='#652082' className={styles.InfoIcon} />
  }

  return (
    <div className={`${styles.container} ${styles[cssClass]}`}>
      {messageIcon}
      <div>
        {withTitle && <h3 className={styles.title}>{title}</h3>}
        <p className={styles.message}>{message}</p>
      </div>
    </div>
  )
}
export default MessageBox